import { render, staticRenderFns } from "./worksOfExcellenceDetail.vue?vue&type=template&id=67601645&scoped=true"
import script from "./worksOfExcellenceDetail.vue?vue&type=script&lang=js"
export * from "./worksOfExcellenceDetail.vue?vue&type=script&lang=js"
import style0 from "./worksOfExcellenceDetail.vue?vue&type=style&index=0&id=67601645&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67601645",
  null
  
)

export default component.exports